import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { ContentsSettingDataResponse } from '@display-component/shared';
import { ScrapType } from '@remodeling/common';
import { YesOrNo } from '@remodeling/base';
import { useScrap } from '@/hooks';

interface UseExpertSlideItem {
  item: ContentsSettingDataResponse;
  initialScrap: boolean;
}

const useExpertSlideItem = ({ item, initialScrap }: UseExpertSlideItem) => {
  const useScrapProps = {
    id: item.contentsNo,
    name: item.contentsTitle,
    landingUrl: item.appLinkInfoDto?.linkUrl,
    imageUrl: item.imageInfo?.images?.[0]?.imageUrl || '',
    scrapTypeCode: 'CONSTRUCTION_CASE' as ScrapType,
    scrapYn: initialScrap ? 'Y' : ('N' as YesOrNo),
  };

  const router = useRouter();
  const { hasScrap, handleScrap } = useScrap(useScrapProps);

  const handleClickItem = useCallback(() => {
    router.push(item.appLinkInfoDto?.linkUrl);
  }, [item.appLinkInfoDto?.linkUrl, router]);

  return { hasScrap, handleScrap, handleClickItem };
};

export default useExpertSlideItem;
